import { requireSupabase } from '../lib/supabase';

export async function withdrawAccount(): Promise<void> {
  const { data, error } = await requireSupabase().functions.invoke('delete-account', {
    body: { confirmation: '탈퇴' },
  });
  if (error) {
    let message = '회원 탈퇴를 완료하지 못했습니다. 잠시 후 다시 시도해주세요.';
    if (error.context instanceof Response) {
      const body: unknown = await error.context.json().catch(() => null);
      if (body && typeof body === 'object' && 'error' in body && typeof body.error === 'string') message = body.error;
    }
    throw new Error(message);
  }
  if (!data?.ok) throw new Error('회원 탈퇴 결과를 확인하지 못했습니다. 잠시 후 다시 시도해주세요.');
  await requireSupabase().auth.signOut({ scope: 'local' });
}
